export enum OAuthEnum {
  Facebook = 'facebook',
  Google = 'google',
}
